import { extendTheme } from "@chakra-ui/react";

// 🎉 RETRO 90s THEME 🎉
// Best viewed in Netscape Navigator 4.0!

export const chakraTheme = extendTheme({
  fonts: {
    heading: '"Comic Sans MS", "Comic Sans", cursive, sans-serif',
    body: '"Comic Sans MS", "Comic Sans", cursive, sans-serif',
    mono: '"VT323", "Courier New", monospace',
  },
  colors: {
    brand: {
      "50": "#ff00ff",
      "100": "#ff00ff",
      "200": "#ff00ff",
      "300": "#ff69b4",
      "400": "#ff1493",
      "500": "#ff00ff", // Hot Pink/Magenta
      "600": "#cc00cc",
      "700": "#990099",
      "800": "#660066",
      "900": "#330033",
    },
    retro: {
      hotPink: "#FF1493",
      magenta: "#FF00FF",
      cyan: "#00FFFF",
      lime: "#00FF00",
      yellow: "#FFFF00",
      purple: "#9400D3",
      orange: "#FF6600",
      navy: "#000080",
      teal: "#008080",
      silver: "#C0C0C0",
      gray: "#808080",
      maroon: "#800000",
    },
    yellow: {
      "50": "#FFFFF0",
      "100": "#FFFF00",
      "200": "#FFFF00",
      "300": "#FFFF00",
      "400": "#FFFF00",
      "500": "#FFFF00",
      "600": "#CCCC00",
      "700": "#999900",
      "800": "#666600",
      "900": "#333300",
    },
  },
  styles: {
    global: {
      body: {
        bg: "#000080", // Navy blue background
        color: "#00FFFF", // Cyan text
        fontFamily: '"Comic Sans MS", "Comic Sans", cursive, sans-serif',
      },
      a: {
        color: "#FF00FF",
        textDecoration: "underline",
        _hover: {
          color: "#00FF00",
          textDecoration: "underline",
        },
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontFamily: '"Comic Sans MS", "Comic Sans", cursive, sans-serif',
        fontWeight: "bold",
        textTransform: "uppercase",
      },
      variants: {
        retro: {
          bg: "#C0C0C0",
          color: "#000000",
          border: "3px outset #FFFFFF",
          borderRadius: "0",
          boxShadow: "2px 2px 0px #808080",
          _hover: {
            bg: "#A0A0A0",
            border: "3px inset #808080",
          },
          _active: {
            bg: "#808080",
            border: "3px inset #808080",
          },
        },
        neon: {
          bg: "transparent",
          color: "#00FF00",
          border: "2px solid #00FF00",
          borderRadius: "0",
          textShadow: "0 0 10px #00FF00, 0 0 20px #00FF00",
          _hover: {
            bg: "#00FF00",
            color: "#000000",
            boxShadow: "0 0 20px #00FF00",
          },
        },
        hotPink: {
          bg: "#FF1493",
          color: "#FFFFFF",
          border: "3px outset #FF69B4",
          borderRadius: "0",
          boxShadow: "2px 2px 0px #8B008B",
          _hover: {
            bg: "#FF69B4",
            border: "3px inset #FF1493",
          },
        },
      },
      defaultProps: {
        variant: "retro",
      },
    },
    Heading: {
      baseStyle: {
        fontFamily: '"Comic Sans MS", "Comic Sans", cursive, sans-serif',
        textShadow: "2px 2px 0px #FF00FF, 4px 4px 0px #00FFFF",
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: "#C0C0C0",
          border: "3px outset #FFFFFF",
          borderRadius: "0",
          boxShadow: "4px 4px 0px #808080",
        },
      },
    },
  },
});

export default chakraTheme;
